// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as Blog$BenfaerberBlog from "../lib/Blog.bs.js";

function s(prim) {
  return prim;
}

function Author(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                      className: "pfp",
                      alt: "Article Author",
                      src: "images/benfaerber-sm.webp",
                      width: "32px"
                    }),
                JsxRuntime.jsx("div", {
                      children: "Ben Faerber",
                      className: "author-name"
                    }),
                JsxRuntime.jsx("div", {
                      children: Blog$BenfaerberBlog.getPrettyDate(props.date),
                      className: "blog-date"
                    })
              ],
              className: "author is-flex is-align-items-center"
            });
}

var make = Author;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
